import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Deo = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.02 80.63">
  <G fill={color}>
    <Path d="M17.21,0h-2.41C6.64,0,0,6.64,0,14.81v15.59c0,2.21,1.31,4.02,2.89,5.4-1.79,1.74-2.89,4.17-2.89,6.84v30.29c0,4.25,3.45,7.7,7.7,7.7h16.62c4.25,0,7.7-3.45,7.7-7.7v-30.29c0-2.67-1.1-5.1-2.89-6.84,1.57-1.38,2.89-3.2,2.89-5.4v-15.59c0-8.17-6.64-14.81-14.81-14.81ZM9.7,50.47c0-1.61,1.31-2.92,2.92-2.92h6.79c1.61,0,2.92,1.31,2.92,2.92v15.81c0,1.61-1.31,2.92-2.92,2.92h-6.79c-1.61,0-2.92-1.31-2.92-2.92v-15.81ZM14.81,5.83h2.41c4.95,0,8.98,4.03,8.98,8.98v8.14H5.83v-8.14c0-4.95,4.03-8.98,8.98-8.98Z"/>
  </G>
</Svg>
);
};

export default Deo;
